import { getDoc, getFirestore } from "firebase/firestore";
import { dispatchProps } from "../cnr/reducers/reducerHelpers/dispatchProps";
import { callFunction } from "./fbAll";

const transferGenericTypes = {
  transferGeneric: 'transferGeneric',
}

const transferFunctionTypes = {
  getOtherData: 'getOtherData',
  getProdData: 'getProdData',
  getProdSettings: 'getProdSettings',
  getProductionEventAuths: 'getProductionEventAuths',
  transferAppSettings: 'transferAppSettings',
  transferClientToProd: 'transferClientToProd',
  transferEventData: 'transferEventData',
  transferDataBetweenDatabases: 'transferDataBetweenDatabases',
  transferDataToProd: 'transferDataToProd',
  transferDirect: 'transferDirect',
  transferDirectPath: 'transferDirectPath',
  transferDirectCollection: 'transferDirectCollection',
  transferEventToProd: 'transferEventToProd',
  transferManifests: 'transferManifests',
  transferSettings: 'transferSettings',
  transferSettingsToProd: 'transferSettingsToProd',
  transferStorageToProduction: 'transferStorageToProduction',
  transferAllCollections: 'transferAllCollections',
  transferAllSettings: 'transferAllSettings',
}

const callFsFunction = async (fsCall, callData) => {
  const data = await fsCall(transferGenericTypes.transferGeneric, callData)
  return data
}

export const fsfn_transfer = (fsCall) => ({
  getProductionData: (pathViews, collectionName, productionSettings, logging, callback) => fsfn_getProductionData(fsCall, pathViews, collectionName, productionSettings, logging, callback),
  getProductionSettings: (settingsKey, callback) => fsfn_getProductionSettings(fsCall, settingsKey, callback),
  getProductionEventAuths: (eventKey, callback) => fsfn_getProductionEventAuths(fsCall, eventKey, callback),
  transferAppSettings: (projectIds, callback) => fsfn_transferAppSettings(fsCall, projectIds, callback),
  transferClientToProd: (createInfo, pathViews, productionSettings, optz, logging) => fsfn_transferClientToProd(fsCall, createInfo, pathViews, productionSettings, optz, logging),
  transferEventData: (projectIds, pvKeys, showLogs, transfers, clearCollections, callback) => fsfn_transferEventData(fsCall, projectIds, pvKeys, showLogs, transfers, clearCollections, callback),
  transferDataBetweenDatabases: (collections, source, destination, merge, showLogs) => transferDataBetweenDatabases(fsCall, collections, source, destination, merge, showLogs),
  transferDataToProd: (pathViews, collections, itemKey, productionSettings, dataToTransfer, merge, logging) => fsfn_transferDataToProd(fsCall, pathViews, collections, itemKey, productionSettings, dataToTransfer, merge, logging),
  transferDirect_path: (projectIds, paths, dispatch) => fsfn_transferDirect_path(fsCall, projectIds, paths, dispatch),
  transferDirect_ts: (projectIds, showLogs, paths, currentItem, subDocument) => fsfn_transferDirect_ts(fsCall, projectIds, showLogs, paths, currentItem, subDocument),
  transferDirect: (fss, showLogs, paths, transferCollections) => fsfn_transferDirect(fsCall, fss, showLogs, paths, transferCollections),
  transferEventToProd: (createInfo, pathViews, productionSettings, optz, logging) => fsfn_transferEventToProd(fsCall, createInfo, pathViews, productionSettings, optz, logging),
  transferManifests: (projectIds, pvKeys, callback) => fsfn_transferManifests(fsCall, projectIds, pvKeys, callback),
  transferSettings: (projectIds, pvKeys, callback) => fsfn_transferSettings(fsCall, projectIds, pvKeys, callback),
  transferSettingsToProd: (settingsDocName, logging) => fsfn_transferSettingsToProd(fsCall, settingsDocName, logging),

  transferAllCollections: (projectIds, pvKeys, logging) => transferAllCollections(fsCall, projectIds, pvKeys, logging),
  transferAllSettings: (projectIds, pvKeys, logging) => transferAllSettings(fsCall, projectIds, pvKeys, logging),
})

const fsfn_transferDirect = async (fsCall, fss, showLogs, paths, transferCollections) => {

  const projectIds = {
    source: fss && fss.source && fss.source._databaseId && fss.source._databaseId.projectId ? fss.source._databaseId.projectId : null,
    destination: fss && fss.destination && fss.destination._databaseId && fss.destination._databaseId.projectId ? fss.destination._databaseId.projectId : null
  }

  const callData = { projectIds, showLogs, paths, transferCollections }
  callData.transferFunctionType = transferFunctionTypes.transferDirect
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK 
    return response_data
  } catch (error) {
    console.error(error)
  }
}

const transferAllCollections = async (fsCall, projectIds, pvKeys, dispatch) => {
  const callData = { projectIds, pvKeys, showLogs: true }
  callData.transferFunctionType = transferFunctionTypes.transferAllCollections
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK 
    dispatch && dispatch({ type: dispatchProps.success, dispatch })
    return response_data
  } catch (error) {
    console.error(error)
  }
}

const transferAllSettings = async (fsCall, projectIds, pvKeys, dispatch) => {
  const callData = { projectIds, pvKeys, showLogs: true }
  callData.transferFunctionType = transferFunctionTypes.transferAllSettings
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK 
    dispatch && dispatch({ type: dispatchProps.success, dispatch })
    return response_data
  } catch (error) {
    console.error(error)
  }
}

const fsfn_transferDirect_path = async (fsCall, projectIds, paths, dispatch) => {
  const callData = { projectIds, paths, showLogs: true }
  callData.transferFunctionType = transferFunctionTypes.transferDirectPath
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK 
    dispatch && dispatch({ type: dispatchProps.success, dispatch })
    return response_data
  } catch (error) {
    console.error(error)
  }
}

const fsfn_transferDirect_ts = async (fsCall, projectIds, showLogs, paths, currentItem, subDocument) => {
  const callData = { projectIds, showLogs, paths, subCollection: currentItem.subCollection, subDocument }
  callData.transferFunctionType = transferFunctionTypes.transferDirectCollection
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK 
    return response_data
  } catch (error) {
    console.error(error)
  }
}

const fsfn_transferEventData = async (fsCall, projectIds, pvKeys, showLogs, transfers, clearCollections, callback) => {

  const callData = { pvKeys, projectIds, showLogs, transfers, clearCollections }
  callData.transferFunctionType = transferFunctionTypes.transferEventData
  try {
    console.log('callData', callData)
    // callback()
    // return;
    const response_data = await callFsFunction(fsCall, callData)
    console.log('response_data', response_data)
    callback && callback(response_data)
    return response_data
  } catch (error) {
    console.error(error)
  }
}

const transferDataBetweenDatabases = async (fsCall, collections, source, destination, merge, showLogs) => {
  const callData = { collections, source, destination, merge, showLogs }
  callData.transferFunctionType = transferFunctionTypes.transferDataBetweenDatabases
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK 
    return response_data
  } catch (error) {
    console.error(error)
  }
}

const fsfn_transferClientToProd = async (fsCall, createInfo, pathViews, productionSettings, optz, logging) => {
  const callData = { createInfo, pathViews, showLogs: logging && logging.allowLogging && logging.logTransferEventToProd }
  const { noClientSettings } = optz ?? {}
  try {
    const { createInfo } = callData ?? {}
    const { projectData } = createInfo ?? {}
    const { eventData } = projectData ?? {}
    let { id: eventKey } = eventData
    callData.settingsDocKey = eventKey
    callData.pathViews = pathViews
    callData.transferFunctionType = transferFunctionTypes.transferClientToProd
    callData.productionSettings = productionSettings
    callData.noClientSettings = noClientSettings
    const response_data = await callFsFunction(fsCall, callData) // OK
    return response_data
  } catch (error) {
    console.error(error)
  }
}


/**
 * Transfers data to production
 * @param {object} createInfo 
 * @param {string} pathViews 
 * @param {object} logging 
 * @returns 
 */
const fsfn_transferEventToProd = async (fsCall, createInfo, pathViews, productionSettings, optz, logging) => {
  const callData = { createInfo, pathViews, showLogs: logging && logging.allowLogging && logging.logTransferEventToProd }
  const { noClientSettings } = optz ?? {}
  try {
    const { createInfo } = callData ?? {}
    const { projectData } = createInfo ?? {}
    const { eventData } = projectData ?? {}
    let { id: eventKey } = eventData
    callData.settingsDocKey = eventKey
    callData.pathViews = pathViews
    callData.transferFunctionType = transferFunctionTypes.transferEventToProd
    callData.productionSettings = productionSettings
    callData.noClientSettings = noClientSettings
    callData.merge = false
    const response_data = await callFsFunction(fsCall, callData) // OK
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/**
 * Transfers settings data to production
 * @param {string} settingsDocName 
 * @param {boolean} logging 
 * @returns 
 */
const fsfn_transferSettings = async (fsCall, projectIds, pvKeys, callback) => {
  const callData = { transferFunctionType: transferFunctionTypes.transferSettings, projectIds, pvKeys, showLogs: true }
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK 
    callback && callback(response_data)
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/**
 * Transfers settings data to production
 * @param {string} settingsDocName 
 * @param {boolean} logging 
 * @returns 
 */
const fsfn_transferManifests = async (fsCall, projectIds, pvKeys, callback) => {
  const callData = { transferFunctionType: transferFunctionTypes.transferManifests, projectIds, pvKeys, showLogs: true }
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK 
    callback && callback(response_data)
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {object} projectIds 
 * @returns the result
 * @description updates the appSettings and appForms
 */
const fsfn_transferAppSettings = async (fsCall, projectIds, callback) => {
  const callData = { transferFunctionType: transferFunctionTypes.transferAppSettings, projectIds, showLogs: true }
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK 
    callback && callback(response_data)
    return response_data
  } catch (error) {
    console.error(error)
  }
}


/**
 * Transfers settings data to production
 * @param {string} settingsDocName 
 * @param {boolean} logging 
 * @returns 
 */
const fsfn_transferSettingsToProd = async (fsCall, settingsDocName, logging) => {
  const callData = { transferFunctionType: transferFunctionTypes.transferSettingsToProd, settingsDocKey: settingsDocName, showLogs: true }
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/**
 * Gets the data in Dev add the data to Production using Set
 * @param {string} pathViews 
 * @param {object} collections 
 * @param {object} logging 
 * @returns response_data {success, result, error}
 */
const fsfn_transferDataToProd = async (fsCall, pathViews, collections, itemKey, productionSettings, dataToTransfer, merge, logging) => {
  const callData = {
    createInfo: {
      collections,
      itemKey,
      dataToTransfer
    },
    pathViews,
    productionSettings,
    showLogs: true, //logging && logging.allowLogging && logging.logTransferSettingsToProd,
    transferFunctionType: transferFunctionTypes.transferDataToProd,
    merge
  }
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK 
    return response_data
  } catch (error) {
    console.error(error)
  }
}

const fsfn_getProductionEventAuths = async (fsCall, eventKey, callback) => {
  const callData = {
    eventKey,
    showLogs: true, //logging && logging.allowLogging && logging.logTransferSettingsToProd,
    transferFunctionType: transferFunctionTypes.getProductionEventAuths
  }
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK
    const { result } = response_data
    callback && callback(result)
    return response_data
  } catch (error) {
    console.error(error)
  }
}


const fsfn_getProductionData = async (fsCall, pathViews, collectionName, productionSettings, logging, callback) => {
  const callData = {
    createInfo: {
      collectionName
    },
    pathViews,
    productionSettings,
    showLogs: true, //logging && logging.allowLogging && logging.logTransferSettingsToProd,
    transferFunctionType: transferFunctionTypes.getProdData
  }
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK
    const { result } = response_data
    callback && callback(result)
    return response_data
  } catch (error) {
    console.error(error)
  }
}

const fsfn_getProductionSettings = async (fsCall, settingsKey, callback) => {
  const callData = {
    settingsKey,
    transferFunctionType: transferFunctionTypes.getProdSettings
  }
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK
    const { result } = response_data
    callback && callback(result)
    return response_data
  } catch (error) {
    console.error(error)
  }
}